// Bilingual display helpers. English is the stored default; _fr fields override when lang==='fr'.
export const loc = (obj, field, lang) => {
  if (!obj) return '';
  if (lang === 'fr' && obj[`${field}_fr`]) return obj[`${field}_fr`];
  return obj[field] || '';
};

const SECTOR_FR = { Energy: 'Énergie', Infrastructure: 'Infrastructure', Agriculture: 'Agriculture', Climate: 'Climat', Water: 'Eau', Transport: 'Transport', Health: 'Santé', Finance: 'Finance' };
const COUNTRY_FR = {
  // Sub-Saharan Africa
  Senegal: 'Sénégal', Benin: 'Bénin', Nigeria: 'Nigéria', Cameroon: 'Cameroun',
  Ethiopia: 'Éthiopie', 'South Africa': 'Afrique du Sud', Tanzania: 'Tanzanie',
  Uganda: 'Ouganda', Zambia: 'Zambie',
  // North Africa & Middle East
  Morocco: 'Maroc', Egypt: 'Égypte', Tunisia: 'Tunisie', Algeria: 'Algérie',
  Jordan: 'Jordanie', Lebanon: 'Liban',
  // Asia & Pacific
  India: 'Inde', Indonesia: 'Indonésie', Vietnam: 'Viêt Nam', Philippines: 'Philippines',
  Nepal: 'Népal', Cambodia: 'Cambodge', Mongolia: 'Mongolie',
  // Latin America & Caribbean
  Brazil: 'Brésil', Mexico: 'Mexique', Colombia: 'Colombie', Peru: 'Pérou',
  Argentina: 'Argentine', Chile: 'Chili', Ecuador: 'Équateur',
  'Dominican Republic': 'République dominicaine',
  // Europe & Central Asia
  Turkey: 'Turquie', Georgia: 'Géorgie', Kazakhstan: 'Kazakhstan',
  Uzbekistan: 'Ouzbékistan', Serbia: 'Serbie',
};
const STAGE_FR = { Early: 'Amont', Structuring: 'Structuration', 'Investment-ready': 'Prêt à investir' };
const RISK_FR = { Low: 'Faible', Medium: 'Moyen', High: 'Élevé' };

const enumFr = (map, val, lang) => (lang === 'fr' && val && map[val]) ? map[val] : val;

const ALL_FR = { ...SECTOR_FR, ...COUNTRY_FR, ...STAGE_FR, ...RISK_FR };
const _esc = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// Translate known enum words (sectors, countries, stages, risk levels) inline within a free-text string.
export const frInline = (text, lang) => {
  if (lang !== 'fr' || !text) return text;
  let s = String(text);
  Object.keys(ALL_FR).sort((a, b) => b.length - a.length).forEach((k) => {
    s = s.replace(new RegExp(`\\b${_esc(k)}\\b`, 'g'), ALL_FR[k]);
  });
  return s;
};

export const sectorLabel = (v, lang) => enumFr(SECTOR_FR, v, lang);
export const countryLabel = (v, lang) => enumFr(COUNTRY_FR, v, lang);
export const stageLabel = (v, lang) => enumFr(STAGE_FR, v, lang);
export const riskLabel = (v, lang) => enumFr(RISK_FR, v, lang);
